<template>
  <div class="card listing-basic">
    <div class="listing-basic-top">
      <div
        v-if="listing.images.length"
        class="image"
      >
        <router-link :to="{ name: 'profile', params: { id: String(listing.id ) } }">
          <images
            :images="listing.images"
            :detail="detail"
          />
        </router-link>
      </div>

      <div>
        <div class="title-and-menu">
          <div class="title">
            <router-link
              :to="{ name: 'probile', params: { id: String(listing.id) } }"
              class="body-color"
            >
              {{ listing.title }}
            </router-link>
          </div>

          <item-menu
            v-if="userData"
            :listing="listing"
          />
        </div>

        <router-link
          :to="{ name: 'post_detail', params: { id: String(listing.id) } }"
          class="body-color"
        >
          <div class="description">
            {{ listing.description }}
          </div>
        </router-link>

        <div class="stats">
          <router-link :to="{ name: 'profile', params: { id: String(listing.id ) } }">
            {{ dateFromNow(listing.created) }}
          </router-link>
        </div>

        <hr class="stretched">

        <router-link
          :to="{ name: 'post_detail', params: { id: String(listing.id) } }"
          class="price-and-view"
        >
          <div>
            <span class="price">
              {{ formatPrice(listing.price) }}
            </span>

            <auction-time
              v-if="listing.auction_end"
              :auction-end="listing.auction_end"
              class="body-color"
            />
          </div>

          <span>View</span>
        </router-link>
      </div>
    </div>

    <div class="actions">
      <template v-if="userData">
        <like :listing="listing" />

        <router-link
          :to="{ name: 'post_detail', params: { id: String(listing.id) } }"
          class="comment-link body-color"
        >
          <comment-outline-icon />
          <span class="small">Comment</span>
        </router-link>
      </template>

      <div class="star-and-share">
        <star
          v-if="userData"
          :post="listing"
        />

        <share />
      </div>
    </div>
  </div>
</template>

<script>
import AuctionTime from '@/components/AuctionTime.vue';
import Images from '@/components/Images.vue';
import ItemMenu from '@/components/ItemMenu.vue';
import Like from '@/components/Like.vue';
import Share from '@/components/Share.vue';
import Star from '@/components/Star.vue';

export default {
  components: {
    AuctionTime,
    Images,
    ItemMenu,
    Like,
    Share,
    Star,
  },
  props: {
    listing: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .listing-basic-top {
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: 1fr 1.5fr;
  }

  .image {
    margin-top: -8px;
    margin-left: -8px;
    border-top-left-radius: 0.25rem;
    overflow: hidden;
  }

  .title-and-menu {
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: 1fr auto;
  }

  .title {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.2rem;
  }

  .price-and-view {
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: 1fr auto;

    > span {
      color: var(--blue-light);
      font-size: 80%;
      font-weight: 500;
      text-transform: uppercase;
    }
  }

  .actions {
    margin-top: 0.5rem;
  }

  .star-and-share {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: auto auto;
  }
</style>
